<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Cutoff padrão</span>
    <span class="spacer"></span>
    <button
      mat-raised-button
      color="primary"
      class="history"
      (click)="openExceptionHistory()"
      *ngIf="!isIndex"
    >
      Histórico de Exceções
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="openCreateCutoff(cutoffOperationTypeEnum.Default)"
      *ngIf="!isIndex"
    >
      Cadastrar Novo Cutoff Padrão
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="model" class="hours">
  <ng-container
    matColumnDef="actions"
    *ngIf="canChangeCutoffDefault() || isIndex"
  >
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item" class="actions">
      <fa-icon
        [icon]="faEye"
        title="Visualizar horário padrão por Gestora/Fundo"
        *ngIf="item.hasAccountManagerFundDefault"
        (click)="
          openAccountManagerFundDefault(
            item.ticketCutoffTypeId,
            item.ticketCutoffType
          )
        "
      ></fa-icon>
      <!-- <i class="fa fa-lg fa-sign-out" *ngIf="item.hasAccountManagerFundDefault" (click)="openAccountManagerFundDefault(item.ticketCutoffTypeId, item.ticketCutoffType)" title="Visualizar horário padrão por Gestora/Fundo"></i>&nbsp; -->
      <fa-icon
        [icon]="faListAlt"
        (click)="openTimeUpdate(item.ticketCutoffDefaultId)"
        title="Alterar horário padrão"
        *ngIf="!isIndex"
      ></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Tipo Boleta</th>
    <td mat-cell *matCellDef="let item">{{ item.ticketCutoffType }}</td>
  </ng-container>

  <ng-container matColumnDef="defaultLimitTime">
    <th mat-header-cell *matHeaderCellDef>Horário Limite Padrão</th>
    <td mat-cell *matCellDef="let item">
      <span [class.out-of-vigor]="item.currentLimitTime">
        {{ item.defaultLimitTime | date: "HH:mm":"-0300" }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="currentLimitTime">
    <th mat-header-cell *matHeaderCellDef>Horário Limite Vigente</th>
    <td mat-cell *matCellDef="let item">
      {{ item.currentLimitTime | date: "HH:mm":"-0300" }}
      <fa-icon
        [icon]="faInfoCircle"
        title="Horário válido somente para o dia vigente."
        *ngIf="item.currentLimitTime && item.hasAccountManagerFundDefault"
      ></fa-icon>
      <fa-icon
        [icon]="faInfoCircle"
        title="Abertura de horário válida no dia apenas para o fundo selecionado, demais fundos permanecem com o horário padrão."
        *ngIf="
          item.currentLimitTime &&
          !item.hasAccountManagerFundDefault &&
          item.fundId
        "
      ></fa-icon>
      <fa-icon
        [icon]="faInfoCircle"
        title="Horário válido somente para todos os fundos, para o dia vigente."
        *ngIf="
          item.currentLimitTime &&
          !item.hasAccountManagerFundDefault &&
          !item.fundId
        "
      ></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="request" *ngIf="canChangeLimitTime && !isIndex">
    <th mat-header-cell *matHeaderCellDef>Solicitar extensão horário limite</th>
    <td mat-cell *matCellDef="let item">
      <button
        mat-raised-button
        color="primary"
        (click)="
          openCreateCutoff(
            cutoffOperationTypeEnum.Exception,
            item.ticketCutoffTypeId,
            item.accountManagerId,
            item.fundId
          )
        "
      >
        Solicitar
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
